/* src/app/_shared/components/clients-list/clients-list.component.scss */
ion-list ion-label h2 {
  font-size: 16px;
}
.no-clients-item h4 {
  width: 100%;
  font-weight: bold;
  text-align: center;
}
ion-infinite-scroll-content {
  margin-top: var(--space-top);
  --color: var(--ion-color-primary);
}
/*# sourceMappingURL=clients-list.component.css.map */
